import HRWorkstationS2 from "./HRWorkstationS2";
export default HRWorkstationS2;
